<template>
	<div class="input-product-cart">
		<div @click="shopStore.addItemToCart(item, 1)" class="input-add-product">
			<div class="wrapper-img">
				<picture>
					<source type="image/webp" :srcset="item.imagemin">
					<img :src="item.image"  alt="product image">
				</picture>
			</div>
			<div class="content-input">
				<p class="product-name">{{ item.title }}</p>
				<div class="align-between">
					<p class="quantity">x{{ shopStore.getItemQuantity(item) }}</p>
					<p class="total-price-row-product"><span class="total-price-discount" v-if="shopStore.currencyItemPrice(item, true)">{{ currencyStore.readableCurrencyValue(shopStore.currencyItemPrice(item, true) * shopStore.getItemQuantity(item), false, true, true) }}</span> {{ currencyStore.readableCurrencyValue(shopStore.currencyItemPrice(item) * shopStore.getItemQuantity(item), false, true, true) }}</p>
				</div>
			</div>
		</div>
		<div class="input-uncheck" :class="{active: shopStore.getTotalItemQuantity() > 0}" @click="shopStore.removeItemFromCart(item, 1)">
			<img src="https://img.qromo.io/img/icon-elimina.svg" alt="icon basket">
		</div>
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import {useShopStore} from "@/shop/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const shopStore = useShopStore();
		const currencyStore = useCurrencyStore();
		return {languageStore, currencyStore, getString: languageStore.getString, shopStore};
	},
	name: "ProductCart",
	props: {
		itemId: {
			type: String,
			required: true
		}
	},
	computed: {
		item() {
			return this.shopStore.getItemById(this.itemId);
		}
	}
}
</script>

<style lang="scss" scoped>
.input-product-cart {
	display: flex;
	border-bottom: 1px solid var(--color-alpha-4);
	background-color: var(--color-bg-primary-1);
	.input-add-product {
		display: flex;
		padding: 10px 15px;
		width: 100%;
		cursor: pointer;
		.wrapper-img {
			position: relative;
			width: 70px;
			height: 70px;
			overflow: hidden;
			border-radius: 13px;
			&:after {
				position: absolute;
				content: '';
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				border-radius: 13px;
				box-shadow: inset 1px 2px 3px var(--color-box-shadow-3);
			}
			img {
				object-fit: contain;
				width: 100%;
				height: 100%;
			}
		}
		.content-input {
			padding: 0 0 0 20px;
			width: calc(100% - 70px);
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			.align-between {
				display: flex;
				justify-content: space-between;
				align-items: self-end;
				.quantity {
					font-size: 16px;
					line-height: 25px;
					min-width: 25px;
					border-radius: 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					color: var(--color-txt);
					margin-top: -2px;
					padding: 0 5px;
				}
			}
			.product-name {
				font: normal normal bold 16px/19px Montserrat;
				color: var(--color-txt);
			}
			.total-price-row-product {
				text-align: end;
				font: normal normal bold 16px/18px Montserrat;
				color: var(--color-txt);
				.total-price-discount {
					color: #E24444;
					position: relative;
					margin-right: 6px;
					font-size: 14px;
					font-weight: normal;

					&:after {
						content: "";
						position: absolute;
						top: 44%;
						left: 0;
						width: 100%;
						height: 2px;
						background-color: #E24444;
					}
				}
			}
		}
	}
	.input-uncheck {
		width: 0;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-right: 0;
		opacity: 0;
		transition: width .3s $transition, padding .3s $transition, opacity .3s $transition;
		&.active {
			width: 42px;
			padding-right: 10px;
			opacity: 1;
		}
		img {
			width: 20px;
			height: 20px;
		}
	}
}
</style>